namespace $.$$ {

	export class $bog_pazzle_play extends $.$bog_pazzle_play {

		moves_label() {
			return this.$.$bog_pazzle_store.moves_label( this.moves() )
		}

	}

}
